/*jshint scripturl:true*/
var FacetView = Class({

    initialize: function() {
		this.searchFilterbarTemplate = Rayban.templates.search_filter_bar_template;
		this.sunglassesFilterbarTemplate = Rayban.templates.sunglasses_filter_bar_template;
		this.eyeglassesFilterbarTemplate = Rayban.templates.eyeglasses_filter_bar_template;
		this.filterProductCategoriesTemplate = Rayban.templates.filter_product_categories_template;
		this.filterProductDetailsTemplate = Rayban.templates.filter_product_details_template;
		this.filterSelectedTemplate = Rayban.templates.filter_selected_template;
	},

	fetchFacetData: function(){
		var self = this;
		var params = {
				"categoryID": $("#parentCategoryId").val(),
				"storeId": $("#storeId").val(),
				"catalogId": $("#catalogId").val(),
				"langId": $("#langId").val(),
				"searchTerm": $("#searchTerm").val(),
				"facet": getUrlParameter('facet'),
				"token": $("#token").val(),
				"token1": $("#token1").val(),
				"token2": $("#token2").val(),
				"pageTemplateRedesign": $("#pageTemplateRedesign").val()
		};

		if ($("[name=isAsianFitAvailable]").length > 0) {
			// For plp landing
			self.createAsianFitCookie();

			if (params.facet.length > 0) {
				if (!Array.isArray(params.facet)){
					params.facet = [params.facet];
				}
				if (params.facet.indexOf(getCookie("AsianFitDefaultFilter")) === -1) {
					params.facet.push(getCookie("AsianFitDefaultFilter"))
				}
			}
    }

		if($("#pageType").val() === 'SearchResults'){
			delete params.storeId;
			delete params.catalogId;
			delete params.langId;
			params.facet = getUrlParameter('facet');
			params.searchTerm = getUrlParameter('searchTerm').split("+").join(" ");
		}

		$.ajax({
			url: $("#basePageURL").val(),
			type: "get",
			traditional: true,
			data: params,
			success: function(data){
				self.render(data);
				self.bindEvent();
			}

		});
	},

	createAsianFitCookie: function () {
		var cookieName = "AsianFitDefaultFilter";
		if (getCookie(cookieName) === null){
			if ($('#asianFitDefaultDisplay').val() === 'ASIAN') {
				document.cookie = cookieName + "=" + $('#AsianFitAsianFilter').val() + ";path=/;";
			} else {
				document.cookie = cookieName + "=" + $('#AsianFitInternationalFilter').val() + ";path=/;";
			}
		}
	},

	render: function(facetData){
		var self = this;

		var analyticsFacetArr =[];
		var productType = $("#producttype").val();
		var $filterBarContainer = $("#wcs-filter-bar-container");
		var $filterInnerContainer= $(".wcs-filter-inner-container");

		if(typeof facetData != "object")
			data = $.parseJSON(facetData);
		else
			data = facetData;
		if($("#pageTemplate").val() !== "CategoryListing"){
			if(productType !== undefined){
				if(productType.indexOf("sunglasses") !== -1 || productType.indexOf("accessories") !== -1){
          $filterBarContainer.html(self.sunglassesFilterbarTemplate(data));
				}else if(productType.indexOf("eyeglasses") !== -1){
          $filterBarContainer.html(self.eyeglassesFilterbarTemplate(data));
				}else{
          $filterBarContainer.html(self.searchFilterbarTemplate(data));
				}
			}else{
        $filterBarContainer.html(self.searchFilterbarTemplate(data));
			}
		}
		expand_dropbox();

		if (data.PRODUCTTYPE !== undefined) {
			for (var k = 0; k < data.PRODUCTTYPE.entry.length; k++) {
				if (data.PRODUCTTYPE.entry[k] !== null && data.PRODUCTTYPE.entry[k] !== undefined && data.PRODUCTTYPE.entry[k].count===0) {
					if (data.PRODUCTTYPE.entry[k].label === 'Sunglasses Only') {
						$('.wcs-second-group').find('a:first').attr('disabled','disabled');
					} else if (data.PRODUCTTYPE.entry[k].label === 'Optics Only') {
						$('.wcs-second-group').find('a:last').attr('disabled','disabled');
					}
				}
			}
		}

		if(data.APPLIED_FACETS){
			var appliedFacetToShow = { entry: null };
			appliedFacetToShow.entry = data.APPLIED_FACETS.entry.filter(function(obj, index, arr){
				return obj.mainLabel !== 'GEO_FIT';
			});

			appliedFacetToShow.label = data.APPLIED_FACETS.label;
			appliedFacetToShow.RESET_ALL = data.RESET_ALL;

			if (appliedFacetToShow.entry.length > 0) {
        $filterBarContainer.append(self.filterSelectedTemplate(appliedFacetToShow));
			}
        }

		if(undefined !== data && undefined !==data.FRAME_SHAPE_FACET) data.FRAME_SHAPE_FACET.RESET_ALL = data.RESET_ALL;
        if(undefined !== data && undefined !==data.SPECIALS) data.SPECIALS.RESET_ALL = data.RESET_ALL;
        if(undefined !== data && undefined !==data.PRODUCT_DETAILS) data.PRODUCT_DETAILS.RESET_ALL = data.RESET_ALL;
        if(undefined !== data && undefined !==data.PRODUCTTYPE) data.PRODUCTTYPE.RESET_ALL = data.RESET_ALL;

        // enable promo filters in pagepromo
        if (window.location.href.indexOf($('#promo-toggle-url').val()) !== -1) {
          if (data.PRODUCT_DETAILS.BADGE !== 'undefined' && data.PRODUCT_DETAILS.BADGE !== undefined && data.PRODUCT_DETAILS.BADGE !== '') {
            $('#badgeOnlyPartial').remove();
            var arrayLabels = [];
            for (i=0;i<data.PRODUCT_DETAILS.BADGE.entry.length;i++){
              if (data.PRODUCT_DETAILS.BADGE.entry[i].label.toLowerCase() !== 'null' && data.PRODUCT_DETAILS.BADGE.entry[i].label.toLowerCase() !== '') {
                var promoMap = {
                    entryValue: data.PRODUCT_DETAILS.BADGE.entry[i].entryValue,
                    label: data.PRODUCT_DETAILS.BADGE.entry[i].label,
                    count: data.PRODUCT_DETAILS.BADGE.entry[i].count
                };
                arrayLabels.push(promoMap.label);
              }
            }
            arrayLabels.sort();
            for (j=0;j<arrayLabels.length;j++){
                for (k=0;k<data.PRODUCT_DETAILS.BADGE.entry.length;k++){
                    if (data.PRODUCT_DETAILS.BADGE.entry[k].label.indexOf(arrayLabels[j]) !== -1) {
                        // i+1 because badgeCheckbox_0 already exist with All Promo
                            $('#badgeOnlyPartial_promo #badgeCheckbox_'+(j+1)).val(data.PRODUCT_DETAILS.BADGE.entry[k].label);
                            $('#badgeOnlyPartial_promo #badgeCheckbox_'+(j+1)).attr('onclick', 'Javascript:applyFacets("'+data.PRODUCT_DETAILS.BADGE.entry[k].entryValue+'");');
                            if(parseInt(data.PRODUCT_DETAILS.BADGE.entry[k].count) === 0) {
                                $('#badgeOnlyPartial_promo #badgeCheckbox_'+(j+1)).addClass('disabled');
                                $('#badgeOnlyPartial_promo #badgeCheckbox_'+(j+1)).attr('disabled', 'disabled');
                            } else {
                                $('#badgeOnlyPartial_promo #badgeCheckbox_'+(j+1)).removeClass('disabled');
                                $('#badgeOnlyPartial_promo #badgeCheckbox_'+(j+1)).removeAttr('disabled');
                            }
                            $('#badgeOnlyPartial_promo #badgeCheckbox_'+(j+1)).show();
                    }
                }
            }
            // highlight right toggle filter
            $("#badgeOnlyPartial_promo .promoOption").each(function (index) {
              if ($(this).attr('id') !== 'badgeCheckbox_0') {
                var dirtyButtonFacet = $(this).attr('onclick');
                if (dirtyButtonFacet !== undefined && dirtyButtonFacet !== "undefined") {
                  var buttonFacet = dirtyButtonFacet.split('("')[1].replace('");', '');
                  if (window.location.href.indexOf(buttonFacet) !== -1) {
                    $('#badgeCheckbox_0').removeClass('promo-button-active');
                    if ($('.promo-button-active').length === 0) {
                      $("#badgeCheckbox_0").addClass('promo-button-active');
                    }
                  }
                }
              }
            });
            $('#badgeOnlyPartial_promo').css('visibility','visible');
            var sum_width = 0;
            $('.promo_buttons-container li').each(function( index ) {
                sum_width = sum_width + $(this).width();
            });
            $('#badgeOnlyPartial_promo').css('width', sum_width);
          }
        }

    $filterInnerContainer.html(self.filterProductCategoriesTemplate(data.PRODUCTTYPE));
    $filterInnerContainer.append(self.filterProductDetailsTemplate(data.PRODUCT_DETAILS));
		if($('#country').val() === "MX"){
            $('.wcs-sunglass-details .wcs-omega ul:first').css("text-transform","none");
        }

		self.renderEyeGlassDisplay();

		if(data.APPLIED_FACETS && data.APPLIED_FACETS.entry){

			$.each(data.APPLIED_FACETS.entry, function(index, obj){

				var selChk;
				var encodeValue;

				$.each([escape(obj.key), encodeURIComponent(obj.key)], function(index, encodeObj){
					encodeValue = encodeObj;
					selChk = $("input[value='"+ encodeValue +"']");
					if(selChk.length > 0)
						return false;
				});

				var lensOrGenderFlag = obj.mainLabel === "LENS_TREATMENT_FACET" || obj.mainLabel === "GENDER";
				if(!lensOrGenderFlag && selChk.length > 0){
					selChk.attr("checked", "checked");
					var selChkId =  selChk.attr("id");
					selChk.parent().addClass('wcs-check');
					$("label[for='"+ selChkId +"']").attr("onclick", "Javascript:removeFacets('"+ encodeValue +"');");
				}else {

					var escapeArr = obj.key.split(",");
					var encodeArr = [];
					var linkEl = "";
					var ipEl = "";
					escapeArr.forEach(function(o,i){
						escapeArr[i] = escape(o);
						encodeArr[i] = encodeURIComponent(o);
					});

					var newVal = escapeArr.join(",");
					newVal = newVal.split("+").join("");

					newValEncoded = encodeArr.join(",");
					newValEncoded = newValEncoded.split("+").join("");

					$.each([newVal, newValEncoded], function(index, elObj){
						linkEl = $("a[value='"+ elObj +"']");

						if(linkEl.length > 0){
							linkEl.addClass("wcs-added");
							linkEl.attr("onclick", "Javascript:removeFacets('"+ elObj +"', true);");
							return false;
						}
					});

					$.each([newVal, newValEncoded], function(index, elObj){
						var otherChk = $("input[value='"+ elObj +"']");
						if(otherChk.length > 0){
							otherChk.attr("checked", "checked");
							var selChkId =  otherChk.attr("id");
							$("label[for='"+ selChkId +"']").attr("onclick", "Javascript:removeFacets('"+ elObj +"', true);");

							return false;
						}
					});
				}
				if (obj.mainLabel !== undefined) {
          analyticsFacetArr.push(obj.mainLabel.toUpperCase() + '=' + obj.label.toLowerCase().replace(/\"/g, ""))
        }
			});

		}

		if(data.sortOptions){
			$.each(data.sortOptions, function(index, value){
				if(value.cssClass){
					analyticsFacetArr.push('SORT BY=' +value.label.toLowerCase());
				}
			});
    }

    var numberResults = $('#totalCountFacets').val() || '';

    /*tealium_data2track.push({
      id: 'SearchFilterUpdated',
      Search_ResultItemsQnt: numberResults,
      Search_FacetValues_String: analyticsFacetArr.join('|'),
    });*/

		// removed facet link for group
		$.each($('.wcs-filter-refresh'), function(indx, el){
			var removeFacetParam="";
			$.each($(el).find('input:checked'), function(i, chkedIp){
				removeFacetParam += $(chkedIp).val() + ",";
			});
			if(removeFacetParam.length > 0){
				removeFacetParam = removeFacetParam.substring(0, removeFacetParam.length-1);
				if(removeFacetParam.indexOf("UNISEX") !== -1){
					$(el).find(".wcs-reset-icon-lg").attr("onclick", "Javascript:removeFacets('"+removeFacetParam + "', true)");
				}else{
					$(el).find(".wcs-reset-icon-lg").attr("onclick", "Javascript:removeFacets('"+removeFacetParam + "')");
				}
			}
		});

		$.each($('.wcs-frame-shape-model, .wcs-model-specials, .wcs-sunglass-details'), function(indx, el){
			var removeFacetParam="";
			$.each($(el).find('input:checked'), function(i, chkedIp){
				removeFacetParam += $(chkedIp).val() + ",";
			});
			$.each($(el).find('a[onclick^="Javascript:removeFacets"]'), function(i, linkIp){
				removeFacetParam += $(linkIp).eq(0).attr("value") + ",";
			});
			if(removeFacetParam){
				removeFacetParam = removeFacetParam.substring(0, removeFacetParam.length);
				$(el).find(".wcs-reset-link").attr("href", "Javascript:removeFacets('');");
			}
		});

		window.element         = $("#filterByDivArea");
    	if(window.element.length){
    		if(window.topOfElement === undefined && window.bottomOfElement === undefined){
	    		window.topOfElement    = window.element.offset().top;
	    		window.bottomOfElement = window.element.offset().top + window.element.outerHeight(true);
				this.stickyPanelOnOff();
    		}

	    }

    	this.setAsianFitCheck();

		$("#wcs-sort-wrapper1 ul li").off("click").on("click", {"self":this}, this.sortByDropdownSelect);

		$(window).on('scroll onload', this.stickyPanelOnOff);

        this.hideAndShowViewHighlights(data);

        if (window.location.href.indexOf($('#promo-toggle-url').val()) !== -1) {
            $('#badgeOnlyPartial').remove();
        }
	},

	setAsianFitCheck: function() {
		if ($("[name=isAsianFitAvailable]").length > 0) {
    		// plp landing
    		if (getCookie("AsianFitDefaultFilter").indexOf('Asian') > 0) {
    			$('#asianfitCheckbox_1').prop('checked', 'checked');
    		} else {
    			$('#asianfitCheckbox_0').prop('checked', 'checked');
    		}
    	}
	},

	sortByDropdownSelect: function(){
		var allDropdownOptions = $("#wcs-sort-wrapper1 ul li");
		var $basePageURL = $('#basePageURL');
		var basePageUrl = $basePageURL.val();
		var orderbyValue = $(this).attr("data-entry-value");

		allDropdownOptions.removeClass('selected');
		$(this).addClass('selected');
		$("#wcs-sort-display #wcs-selected-sort-option").val($(this).find('.wcs-selectedSortText').text());
		var orderByString = "orderBy="+$(this).attr('data-entry-value');

		if(undefined !== basePageUrl && basePageUrl.indexOf("orderBy=") === -1){
			basePageUrl = basePageUrl+"&"+orderByString;
		}else{
			if(undefined !== basePageUrl && basePageUrl.indexOf("orderBy=") !== -1){
				var splitVar = basePageUrl.split("orderBy=");
				if(undefined !== splitVar && splitVar.length === 2){
					if(undefined !== splitVar[0] && splitVar[0].lastIndexOf('&') === splitVar[0].length -1){
						if(undefined !== splitVar[1] && splitVar[1].indexOf('&') !== -1){
							var startIndex = splitVar[1].indexOf('&');
							var LastIndex = splitVar[1].lenght;
							basePageUrl = splitVar[0]+orderByString+splitVar[1].substring(startIndex,LastIndex);
						}else{
							basePageUrl = splitVar[0]+orderByString;
						}
					}else{
						if(undefined !== splitVar[1] && splitVar[1].indexOf('&') !== -1){
							var startIdx = splitVar[1].indexOf('&');
							var LastIdx = splitVar[1].lenght;
							basePageUrl = splitVar[0]+'?'+orderByString+splitVar[1].substring(startIdx,LastIdx);
						}else{
							if(undefined !== splitVar[0] && splitVar[0].lastIndexOf('?') === splitVar[0].length -1){
								basePageUrl = splitVar[0]+orderByString;
							}else {
								basePageUrl = splitVar[0]+'&'+orderByString;
							}
						}
					}

				}
			}
		}
    $basePageURL.val(basePageUrl);
		loadPanelWrapper(basePageUrl, globalAppliedFactes);

		updateUrlParameter("orderBy",orderbyValue);
		updateUrlParameter("pageSize",$('#facetPageSize').val());
		$('#pageSize').val($('#facetPageSize').val());
	},

	bindEvent: function(){
		window.position_filterpannel();
		window.filterbar();
		window.open_filter();
		window.close_filter();
		window.filter_frame();
		window.filter_color();
	},

	renderEyeGlassDisplay: function(){
    var $sunglassDetails = $(".wcs-sunglass-details");
		var totalFacetCol = $sunglassDetails.children().length;
		var $refCol = $sunglassDetails.children().first().find(".wcs-filter-frame-wrapper");
		var refColh2Count = $refCol.children("h6").length;

		if(totalFacetCol === 4 && refColh2Count === 2){
			var detaach_fameTypeTitle = $refCol.children("h6").last().detach();
			var detach_frameTypeData = $refCol.children("ul").last().detach();
			var $createContainerDiv = $("<div>").addClass("wcs-290 wcs-columns wcs-alpha");
			$createContainerDiv.append(detaach_fameTypeTitle).append(detach_frameTypeData);
      $sunglassDetails.children().first().after($createContainerDiv);
		}
	},

    stickyPanelOnOff: function(){
      var $plpContainer = $(".plp-container");
      var $frameShape = $("#FrameShape");
      var $window = $(window);
      var menuHeight = $(".rb-header").height() + $(".rb-header-dropdown-most-popular").height();
      var headerStartScroll = $("#wcs-filter-bar-container").offset().top - menuHeight - (parseInt($(".branding-tile, .plp-tile[0]").css("margin-top")));
    	var scrollTopPosition   = $window.scrollTop() + $window.height();
        var windowScrollTop     = $window.scrollTop();

        /*if ($("#filterByDivArea").lenght != 0 && $("#wcs-drop-down-new-panel").lenght != 0) {
        	if (windowScrollTop >= headerStartScroll && windowScrollTop < ($("#wcs-filter-bar-container").offset().top)){
        		$(".rb-header").css("position", "absolute");
        		$(".rb-header").css("top", headerStartScroll);
        	}
        	if (windowScrollTop < headerStartScroll) {
        		$(".rb-header").removeAttr('style');
        	}
        } IF HEADER STICKY */

        if (windowScrollTop >= ($("#wcs-filter-bar-container").offset().top)) {
    		$("html").css("overflow-x", "unset");
    	} else {
    		$("html").removeAttr('style');
    	}

        if( windowScrollTop > window.topOfElement && windowScrollTop <= window.bottomOfElement) {
           // Element is partially visible (above viewable area)
        	if($plpContainer.height() > $frameShape.height()){
	        	if(!window.element.is(":visible")){
                    $('.rb-header-standard').removeClass('hide');
                    $('.wcs-primary').find('.wcs-selected').siblings('.wcs-drop_panel').show();
	        		window.element.removeClass("stickyPanel");
              $frameShaperemoveClass("filter-container-position-top");
		        }else{
                    //$('.wcs-drop_panel').hide();
                    //$('.rb-header-standard').addClass('hide');
		        	//window.element.addClass("stickyPanel");
              $frameShape.addClass("filter-container-position-top");
		        }
        	}else{
                $('.rb-header-standard').removeClass('hide');
                $('.wcs-primary').find('.wcs-selected').siblings('.wcs-drop_panel').show();
            	window.element.removeClass("stickyPanel");
            $frameShape.removeClass("filter-container-position-top");
        	}
        }else if( windowScrollTop >= window.bottomOfElement && windowScrollTop > window.topOfElement ) {
            // Element is hidden (above viewable area)
        	if($plpContainer.height() > $frameShape.height()){
	        	if(!window.element.is(":visible")){
                    $('.rb-header-standard').removeClass('hide');
                    $('.wcs-primary').find('.wcs-selected').siblings('.wcs-drop_panel').show();
	        		window.element.removeClass("stickyPanel");
              $frameShape.removeClass("filter-container-position-top");
		        }else{
                    //$('.wcs-drop_panel').hide();
                    //$('.rb-header-standard').addClass('hide');
		        	//window.element.addClass("stickyPanel");
              $frameShape.addClass("filter-container-position-top");
		        }
        	}else{
                $('.rb-header-standard').removeClass('hide');
                $('.wcs-primary').find('.wcs-selected').siblings('.wcs-drop_panel').show();
            	window.element.removeClass("stickyPanel");
            $frameShape.removeClass("filter-container-position-top");
        	}
        }else if( scrollTopPosition < window.topOfElement && scrollTopPosition < window.bottomOfElement ) {
            // Element is hidden (below viewable area)



        }else if( scrollTopPosition < window.bottomOfElement && scrollTopPosition > window.topOfElement ) {
            // Element is partially visible (below viewable area)

        }else{
            // Element is completely visible
            $('.rb-header-standard').removeClass('hide');
            $('.wcs-primary').find('.wcs-selected').siblings('.wcs-drop_panel').show();
        	window.element.removeClass("stickyPanel");
          $frameShape.removeClass("filter-container-position-top");
        }

        var plpScrollBottom = $plpContainer.offset().top + $plpContainer.outerHeight();

        if(windowScrollTop > plpScrollBottom){
        	$("#filterByDivArea").hide();
          $frameShape.hide();
        	$("#productCategoriesContainer").hide();
        	$(".wcs-sunglass-details").hide();
        }else{
          $("#filterByDivArea")
            .toggle($plpContainer.height() !== 0);
          $frameShape.show();
        }
    },

	hideAndShowViewHighlights: function(data){
    $(".view-hightlights-btn")
      .toggle(($("#pageTemplate").val() ==="ProductListing") && data.clvPageURL)
	}

});

$(document).ready(function() {
	//Removed CategoryLanding from Array as part of RB-8265
	var pageType = ['ProductListing', 'SearchDispaly'];
	var $pageTypeVal = $('#pageTemplate').val();

	if($pageTypeVal !== undefined && $.inArray($pageTypeVal,pageType) !== -1 && $("#clearanceVariable").val() !== "true"){
		window.facetView = new FacetView();
		//If in search page, fectch the data only if products are available
		if($("#clientSide").val() != "true" && $("#clientSide") !== undefined){
			window.facetView.fetchFacetData();
		}

		window.plpView = new TilesView('.plp-container');

	}

});


var globalAppliedFactes;
window.applyFacets = function(newFactes, expr) {

	/*
		var newFactes = decodeURIComponent(newFactes);
		var newFactes = encodeURIComponent(newFactes);
	*/
    // read base url and currently applied facets from hidden fields
    // appends new facets to the applied facets and call
    // buildPLVAjax(url,facets)
    // newFactes = ' ntk1:"val1",ntk2:"val2" '
    /* get base plv url */
    var basePageUrl = $('#basePageURL').val();
    /*
     * Fetch previously applied facets ,of format
     * facet=ntk_cs1:"value",facet=ntk_cs2:"value"
     */

    if ($("[name=isAsianFitAvailable]").length > 0 && globalAppliedFactes === ""
    	&& newFactes !== $('#asianfitCheckbox_1').val() && newFactes !== $('#asianfitCheckbox_0').val() ) {
    	globalAppliedFactes = ',' + createFacetValuesExpression($('.asianfit-radio :checked').data("entryValue"));
	}

    var appliedFactes = globalAppliedFactes;
    /* params , which contains all facets */
    var params = "";

    if (window.location.href.indexOf($('#promo-toggle-url').val()) !== -1) {
        // if I'm in promo plp and I've clicked on promo toggle filter.
        if(globalAppliedFactes.indexOf('%25%20OFF') !== -1 && newFactes.indexOf('%25%20OFF') !== -1){
            if(globalAppliedFactes.indexOf('%25%20OFF') !== -1 && newFactes.indexOf('%25%20OFF') !== -1){
                var singleFacet = appliedFactes.split(',');
                for (i=0;i<singleFacet.length;i++) {
                    if (singleFacet[i].indexOf('%25%20OFF') !== -1) {
                        singleFacet[i] = ''; // remove previous promo filter done
                    }
                }
                singleFacet = singleFacet.filter(function(v){return v!==''});
                appliedFactes = singleFacet.join(',');
            }
            //appliedFactes = "";
        }
    }
    //newFactes=filterFacetParams(newFactes);

    if (expr === undefined || expr === "") {
        params = createFacetValues(newFactes, appliedFactes);
    } else {
        params = createFacetValuesExpression(newFactes, appliedFactes);
    }

    //Analytics code
    try {
        var pageType = $("#pageTemplate").val();
        var producttype = $("#producttype").val();

        if (producttype === undefined && pageType === undefined) {
            producttype = "Search";
            pageType = "InternalSearchResults";
        }
        var decodedParams = decodeURIComponent(params);
        //decodedParams = unescape(decodedParams);
        var s1 = decodedParams.split(',');
        var facetString = "";
        for (var i = 0, len = s1.length; i <len; i++) {
        	if(!s1[i]) continue;
            var s2 = s1[i].split("=");
            var s3 = s2[1];
            var s4 = s3.split(':');
            var facetVal = s4[1];
            var d, e;
            if (facetVal.indexOf('or') != -1) {
                d = facetVal.split("+");
                e = d[2];
            }
            var key = s4[0];
            key = key.replace(/\(/g, '');
            var s5 = s4[0].split('_'),
                s5len = s5.length,
                facet = s5[s5len - 3],
                charContain,
                matches;

            if (facet !== undefined) {
                 charContain = facet.indexOf('f');
                 matches = facet.match(/\d+/g);
            } else {
                facet = key;
            }
            if (matches !== undefined && matches !== null && charContain !== undefined && charContain != -1) {
                var value = $('#facetFieldNameMap').attr('value').replace(/ /g, '');
                value = $('#facetFieldNameMap').attr('value').replace(/\=/g, ',');
                value = $('#facetFieldNameMap').attr('value').replace(/ /g, '');
                var valueArr = value.split(',');
                var valArr, fctKey, fctKey1;

                for (var j = 0; j < valueArr.length; j++) {
                    valArr = valueArr[j].split('=');
                    if (valArr[0].indexOf(key) !== -1) {
                        fctKey = valArr[1];
                    } else if (valArr[0].indexOf(e) !== -1) {
                        fctKey1 = valArr[1];
                    }
                }

                var facetValKey,facetValKey1;
                if (fctKey !== undefined) {
                    facetValKey = fctKey.replace(/\"/g, '');
                    facetValKey = facetValKey.toLowerCase();
                }
                if (fctKey1 !== undefined) {
                    facetValKey1 = fctKey1.replace(/\"/g, '');
                    facetValKey1 = facetValKey1.toLowerCase();
                }
                if (facetVal.indexOf('or') !== -1 && facetValKey1 !== null && facetValKey1 !== undefined && facetValKey1 !== '') {
                    var facetValFrmClr = facetVal.split('+');
                    facetString = facetString.concat(facetValKey, '_', facetValFrmClr[0], '+or+', facetValKey1, '|');
                }
                if (facetVal.indexOf('or') === -1 && facetValKey !== null && facetValKey !== undefined && facetValKey !== '') {
                    facetString = facetString.concat(facetValKey, '_', facetVal, '|');
                }
            } else {
                facetString = facetString.concat(facet, '_', facetVal, '|');
            }
        }
        facetString = facetString.slice(0, (facetString.length - 1));
    } catch (err) {

    }
    /* Load the ajax */
    loadPanelWrapper(basePageUrl, params, "1");

    $("#pageSize").val($("#facetPageSize").val());
    if($("#pageType").val() !==undefined && $("#pageType").val()==="SearchResults"){
    	updateUrlParameter("pageSize",$("#facetPageSize").val());
    }
    $("#shownProductCount span:first-child").text($("#pageSize").val());


};

window.removeFacetsEscape = function(expiredFactes, expr) {
	var encodeValue;
	$.each([escape(expiredFactes), encodeURIComponent(expiredFactes)], function(index, encodeObj){
    encodeValue = encodeObj;
    encodeValue = encodeValue.replace(/%2C/g, ",");
	});

	self.removeFacets(encodeValue, expr);
};

window.applyStandardFit = function() {
	// handle asian fit facet
	document.cookie = "AsianFitDefaultFilter=" + $('#AsianFitInternationalFilter').val() + ";path=/;";
	var standardFactes = $('#asianfitCheckbox_0').data("entryValue");
	var asianFacet = $('#asianfitCheckbox_1').data("entryValue");

	asianFacet=filterFacetParams(asianFacet);
    var appliedFactes = globalAppliedFactes;
    var params = "";

    if (appliedFactes !== undefined) {
        params = removeFacetValuesExpression(asianFacet, appliedFactes);
        params = removeFacetValuesExpression(filterFacetParams(standardFactes), params);
        globalAppliedFactes = params;
    }

    window.applyFacets(standardFactes, true);
};

window.applyAsianFit = function() {
	// handle asian fit facet
	document.cookie = "AsianFitDefaultFilter=" + $('#AsianFitAsianFilter').val() + ";path=/;";
	var standardFactes = $('#asianfitCheckbox_0').data("entryValue");
	var asianFacet = $('#asianfitCheckbox_1').data("entryValue");

	standardFactes=filterFacetParams(standardFactes);
    var appliedFactes = globalAppliedFactes;
    var params = "";

    if (appliedFactes !== undefined) {
        params = removeFacetValuesExpression(standardFactes, appliedFactes);
        params = removeFacetValuesExpression(filterFacetParams(asianFacet), params);
        globalAppliedFactes = params;
    }

    window.applyFacets(asianFacet, true);
};

//same will be used for all reset all fucntions
window.removeFacets = function(expiredFactes, expr) {
    // read base url and currently applied facets from hidden fields
    // remove new facets from the applied facets and call
    // buildPLVAjax(url,facets)
    // newFactes = ' ntk1:"val1",ntk2:"val2"

    /* get base plv url */
    var basePageUrl = $('#basePageURL').val();
	/*var expiredFactes = decodeURIComponent(expiredFactes);
		 expiredFactes = encodeURIComponent(expiredFactes);
*/
    /*
     * Fetch previously applied facets ,of format
     * facet=ntk_cs1:"value",facet=ntk_cs2:"value"
     */

    expiredFactes=filterFacetParams(expiredFactes);
    var appliedFactes = globalAppliedFactes;
    /* params , which contains all facets */
    var params = "";

    if (appliedFactes !== undefined) {

        /*
         * For reset all , in that case expiredFactes will come
         * empty
         */
        if (expiredFactes !== undefined && expiredFactes !== '') {
            if (expr === undefined || expr === "") {
                params = removeFacetValues(expiredFactes, appliedFactes);
            } else {
                params = removeFacetValuesExpression(expiredFactes, appliedFactes);
            }
        }

        if ($("[name=isAsianFitAvailable]").length > 0 && expiredFactes === "") {
        	params = createFacetValuesExpression($('.asianfit-radio :checked').data("entryValue"));
    	}

        globalAppliedFactes = params;
        if (params === undefined || (params.length === 0) || (params === "")) {
            checkedFiltersArray = [];
            checkedDivs = [];
        }
        if (params !== undefined && params.length > 0) {
            var compareParams = params.split(',');
            var isAnyFrameSelected = 0;
            var j = 0;
            for (i = 0; i < compareParams.length; i++) {
                var facet = compareParams[i].replace(/facet=/g, '');
                if (i === 0) {
                    checkedFiltersArray = [];
                }
                checkedFiltersArray.push(facet);
                if (facet !== "" && $('input[value="' + facet + '"]').parent().parent().hasClass('wcs-filter-frame')) {
                    var framename = $($('input[value="' + facet + '"]').parent().parent().children()[0]).attr('class').split(' ')[1];
                    isAnyFrameSelected = 1;
                    if (j === 0) {
                        checkedDivs = [];
                    }
                    checkedDivs.push(framename);
                    j = j + 1;
                }
            }
            if (isAnyFrameSelected === 0) {
                checkedDivs = [];
            }
        }
        /* Load the ajax */
        loadPanelWrapper(basePageUrl, params, "0");
        if (window.location.href.indexOf($('#promo-toggle-url').val()) !== -1) {
            if(expiredFactes.indexOf('%25%20OFF') !== -1 || expiredFactes === ''){
                $('.promoOption').removeClass('promo-button-active')
                $('#badgeCheckbox_0').addClass('promo-button-active')
            }
        }
        //window.facetView.bindEvent();
    }
    $("#pageSize").val($("#facetPageSize").val());
    if($("#pageType").val() !==undefined && $("#pageType").val()==="SearchResults"){
    	updateUrlParameter("pageSize",$("#facetPageSize").val());
    }
    $("#shownProductCount span:first-child").text($("#pageSize").val());

};

/* Load panel wrapper calls the load panel that renders the facets */
window.loadPanelWrapper = function(baseUrl, params, isApplyFilter) {
    /* Create cookie for back button */
    /* Get the ajax divs */
    /* Parent page divs */
    var srcDivs = new Array(3);
    srcDivs[0] = "categoryListingMain";
    srcDivs[1] = "filterByDivArea";
    srcDivs[2] = "facetDivArea";

    /* Ajax response page divs */
    var destDivs = new Array(3);
    destDivs[0] = "categoryListingMain";
    destDivs[1] = "filterByDivArea";
    destDivs[2] = "facetDivArea";

    /* Load ajax */
    loadPanels(baseUrl, params, srcDivs, destDivs, 'POST', false, isApplyFilter);
};

/*
 * CLV/PLV/CLP
 */
var checkedFilters, checkedFiltersArray, checkedDivs;
$('#facetDivArea').off('click').on('click', '.wcs-filter-check', function(e) {
    if (!$(this).is('.disabled') && !$(this).parent().is('.disabled')) {
        if ($(this).is('.wcs-f-on')) {
            $(this).removeClass('wcs-f-on');
            if ($(this).parent().hasClass('wcs-filter-frame')) {
                $(this).parent().removeClass('wcs-check');
            }
        } else {
            $(this).addClass('wcs-f-on');
            if ($(this).parent().hasClass('wcs-filter-frame')) {
                $(this).parent().addClass('wcs-check');
            }
        }
    }
    checkedFilters = $('label.wcs-f-on').find('input');
    var checkedSpans = $('div.wcs-filter-frame.wcs-check').find('span.wcs-frame-icon');
    if ((checkedDivs === undefined) || (checkedDivs.length > 0)) {
        checkedDivs = [];
    }
    for (i = 0; i < checkedSpans.length; i++) {
        checkedDivs.push($(checkedSpans[i]).attr('class').split(' ')[1]);
    }
    if ((checkedFiltersArray === undefined) || (checkedFiltersArray.length === 0)) {
        checkedFiltersArray = [];
    }

    $.each(checkedFilters, function() {
        checkedFiltersArray.push($(this).attr('value'));
    });
    e.preventDefault();
});
window.colorswatchsFn = function() {
    $('.wcs-color-icon').off('click').on('click', function(e) {
        if (!$(this).is('.wcs-color-unavailable')) {
            if ($(this).is('.wcs-added')) {
                $(this).removeClass('wcs-added');
            } else {
                $(this).addClass('wcs-added');
            }
        }
        checkedFilters = $('a.wcs-added');
        if ((checkedFiltersArray === undefined) || (checkedFiltersArray.length === 0)) {
            checkedFiltersArray = [];
        }
        $.each(checkedFilters, function() {
            checkedFiltersArray.push($(this).attr('value'));
        });
    });
};
colorswatchsFn();

var facetFromURL = getUrlParameter('facet');
if(facetFromURL.length > 0){

	if(typeof facetFromURL == "string"){

		globalAppliedFactes = "facet=" + encodeURIComponent(getUrlParameter('facet'));

	}else if(typeof facetFromURL == "object"){

		$.each(facetFromURL,function(k,v){
			if(globalAppliedFactes === ''){
				globalAppliedFactes = "facet=" + encodeURIComponent(v);
			}else{
				globalAppliedFactes += ',facet='+encodeURIComponent(v);
			}
		});
		globalAppliedFactes = globalAppliedFactes.replace("undefined,", '');
	}
}else{
	globalAppliedFactes = "";
}



//To have all frame colors solr ids in an array
var framecolors = [];
$.each($('input.framecolors'), function() {
    framecolors.push($(this).attr('name'));
});



//This method is called from producttype facets (Sunglasses Only,
// Optics Only), where clicking on a product type value,
// will remove all other producttype facets and apply the selected
// one.
window.removeApplyFacets = function(expiredFactes, newFacets) {

 var basePageUrl = $('#basePageURL').val();

 var appliedFactes = globalAppliedFactes;

 /* params , which contains all facets */
 var params = "";

 if (appliedFactes !== undefined) {

     /*
      * For reset all , in that case expiredFactes will come
      * empty
      */
     if (expiredFactes !== undefined && expiredFactes !== '') {
         params = removeFacetValues(expiredFactes, appliedFactes);
     }

     params = createFacetValues(newFacets, params);

 } else {
     params = createFacetValues(newFacets, params);
 }
 globalAppliedFactes = params;
 if (params === undefined || (params.length === 0) || (params === "")) {
     checkedFiltersArray = [];
     checkedDivs = [];
 }
 if (params !== undefined && params.length > 0) {
     var compareParams = params.split(',');
     var isAnyFrameSelected = 0;
     var j = 0;
     for (i = 0; i < compareParams.length; i++) {
         var facet = compareParams[i].replace(/facet=/g, '');
         if (i === 0) {
             checkedFiltersArray = [];
         }
         checkedFiltersArray.push(facet);
         if (facet !== "" && $('input[value="' + facet + '"]').parent().parent().hasClass('wcs-filter-frame')) {
             var framename = $($('input[value="' + facet + '"]').parent().parent().children()[0]).attr('class').split(' ')[1];
             isAnyFrameSelected = 1;
             if (j === 0) {
                 checkedDivs = [];
             }
             checkedDivs.push(framename);
             j = j + 1;

         }
     }
     if (isAnyFrameSelected === 0) {
         checkedDivs = [];
     }
 }

 /* Load the ajax */
 loadPanelWrapper(basePageUrl, params);

};

// Method that loads next page in the search results via Ajax call.
window.loadMoreResults = function() {
  var $searchResultsDiv = $('#searchResultsDiv');

    $('#searchResultsLoadMoreContainer').remove();
    var srcDivs = new Array(1);
    srcDivs[0] = $searchResultsDiv.val();
    nextPageURL = $('#nextPageSearch').val();
    $searchResultsDiv.remove();

    if ($('#nextPageSearch').length > 0) {
        var appliedFacets = "";
        if ($('#appliedFacets').length > 0) {
            appliedFacets = $('#appliedFacets').val();
        }
        loadPanels(nextPageURL, appliedFacets, srcDivs, null, 'POST', true);
    }
};

/*
 * Splits facet string to facet value to be passes input :-
 * ntk_cs1:"value",ntk_cs2:"value2" , appliedFacets output :-
 * appliedfacets + facet=ntk_cs1:"value",ntk_cs2:"value2"
 *
 * appliedFacets = facet=ntk_cs1:"value",facet=ntk_cs2:"value"
 */
window.createFacetValues = function(facetVals, appliedFactes) {
    var facetParams = '';
    var facetValArray = facetVals.split(",");
    for (i = 0; i < facetValArray.length; i++) {
        /* Only add if not already existing in the applied facets */
        if (appliedFactes === undefined || appliedFactes === "" || appliedFactes.indexOf(facetValArray[i]) === -1) {

            if (facetParams !== undefined && facetParams.length > 0) {
                facetParams = facetParams + ",";
            }
            facetParams = facetParams + "facet=" + facetValArray[i];

        }

    }

    if (appliedFactes !== undefined) {
        facetParams = appliedFactes + "," + facetParams;
    }
    globalAppliedFactes = facetParams;
    return facetParams;
};

/* Create a facet expression with "OR" for framecolor based facets */
window.createFacetValuesExpression = function(facetVals, appliedFactes) {
    var facetParams = '';
    var facetValArray = [];
    if(facetVals!==null){
        facetValArray = facetVals.split(",");
    }
    for (i = 0; i < facetValArray.length; i++) {
        /* Only add if not already existing in the applied facets */
        if (appliedFactes === undefined || appliedFactes === "" || (appliedFactes.indexOf(facetValArray[i]) === -1 || facetValArray[i].indexOf("UNISEX") !== -1 || facetValArray[i].indexOf("Global") !== -1 ||
						facetValArray[i].indexOf(escape($('#lensCombineValues').val())))) {
            if (facetParams !== undefined && facetParams.length > 0) {
                facetParams = facetParams + "+or+";
            } else {
                facetParams = "facet=";
            }

            facetParams = facetParams + facetValArray[i];
        }
    }
    if (appliedFactes !== undefined) {
        facetParams = appliedFactes + "," + facetParams;
    }
    globalAppliedFactes = facetParams;
    return facetParams;
};

/*
 * Splits appliedFacets string and removes the facets that needs to
 * be removed appliedFacets =
 * facet=ntk_cs1:"value",facet=ntk_cs2:"value"
 *
 * input :- ntk_cs1:"value",ntk_cs2:"value2" output :-
 * facet=ntk_cs1:"value",ntk_cs2:"value2"
 */
window.removeFacetValues = function(facetVals, appliedFactes) {
    var facetParams = "";
    var facetValue;
    var removeParam;
    var appliedFacetList = appliedFactes.split(",");
    //if (facetVals != undefined) {
    //    facetVals = escape(unescape(facetVals));
    //}
    for (i = 0; i < appliedFacetList.length; i++) {
        /* add it to params only if its not part of expired facets */
        /*
         * if a facet param get only the facet value part that is
         * ntk_cs:"value"
         */
        removeParam = false;
        if (appliedFacetList[i].indexOf('facet') !== -1) {
            facetValue = appliedFacetList[i].split("=");
			facetValue[1] = filterFacetParams(facetValue[1]);
            if ((framecolors[0] !== undefined && facetValue[1].indexOf(framecolors[0]) !== -1) ||
                (framecolors[1] !== undefined && facetValue[1].indexOf(framecolors[1]) !== -1) ||
                (framecolors[2] !== undefined && facetValue[1].indexOf(framecolors[2]) !== -1) ||
                (framecolors[3] !== undefined && facetValue[1].indexOf(framecolors[3]) !== -1)) {

                facetValue[1] = facetValue[1].replace(/\+or\+/g, ',');
                facetValue[1] = facetValue[1].replace(/%28/g, '');
                facetValue[1] = facetValue[1].replace(/%29/g, '');
                facetValue[1] = facetValue[1].replace(/\(/g, '');
                facetValue[1] = facetValue[1].replace(/\)/g, '');
            }
            if (facetVals.indexOf(facetValue[1]) !== -1) {
                /* Remove this facet param */
                removeParam = true;
            }

            if (!removeParam) {
                if (facetParams !== undefined && facetParams.length > 0) {
                    facetParams = facetParams + ",";
                }
                facetParams = facetParams + appliedFacetList[i];
            }
        }

    }
    globalAppliedFactes = facetParams;
    return facetParams;
};

// Remove facets with "OR" expressions
window.removeFacetValuesExpression = function(facetVals, appliedFactes) {
    var facetParams = "";
    var facetValue;
    var removeParam;
    var appliedFacetList = appliedFactes.split(",");
    facetValList = [];
    if (facetVals !== undefined  && facetVals.indexOf("UNISEX") === -1) {
        //facetValsDec = unescape(facetVals);
    	//facetVals = facetVals.split(",");
    	if(appliedFactes.indexOf('+') !== -1){
    		facetVals = facetVals.replace(/,/g,'+or+');
    	}else{
    		facetVals = facetVals.replace(/,/g,'%2Bor%2B');
    	}

    }else{

    		if(appliedFactes.indexOf('+') !== -1){
        		facetVals = facetVals.replace(',','+or+');
        	}else{
        		facetVals = facetVals.replace(',','%2Bor%2B');
        	}


    }

    facetValList = new Array(facetVals);

    for (i = 0; i < appliedFacetList.length; i++) {
        /* add it to params only if its not part of expired facets */
        /*
         * if a facet param get only the facet value part that is
         * ntk_cs:"value"
         */
        removeParam = false;
        if (appliedFacetList[i].indexOf('facet') !== -1) {
            facetValue = appliedFacetList[i].split("=");
            //facetValue[1] = unescape(facetValue[1]);
            for (j = 0; j < facetValList.length; j++) {
                if (facetValue[1].indexOf(facetValList[j]) !== -1) {
                    /* Remove this facet param */
                    removeParam = true;
                    //appliedFacetList[i] = unescape(appliedFacetList[i]);
                    appliedFacetList[i] = appliedFacetList[i].replace(facetValList[j], '');
                    appliedFacetList[i] = appliedFacetList[i].replace('+or++or+', '+or+');
                    appliedFacetList[i] = appliedFacetList[i].replace('%28+or+', '%28');
                    appliedFacetList[i] = appliedFacetList[i].replace('%2Bor%2B', '%2B');
                    appliedFacetList[i] = appliedFacetList[i].replace('(+or+', '(');
                    appliedFacetList[i] = appliedFacetList[i].replace('+or+%29', '%29');
                    appliedFacetList[i] = appliedFacetList[i].replace('+or+)', ')');
                    appliedFacetList[i] = appliedFacetList[i].replace('facet=%28%29', '');
                    appliedFacetList[i] = appliedFacetList[i].replace('facet=(%2B)', '');
                    appliedFacetList[i] = appliedFacetList[i].replace('facet=(%2B%2B)', '');
                    appliedFacetList[i] = appliedFacetList[i].replace('facet=(%2B%2B%2B)', '');
                    appliedFacetList[i] = appliedFacetList[i].replace('facet=()', '');
                    appliedFacetList[i] = appliedFacetList[i].replace('facet=', '');
                }
            }

            if (facetParams === "") {
                facetParams = appliedFacetList[i];
            } else {
                facetParams = facetParams + "," + appliedFacetList[i];
            }
        }

    }
    globalAppliedFactes = facetParams;
    return facetParams;
};

window.updateUrlParameter= function(key, value){
	var newUrl;
	var pageUrl = location.href;
	var newSearchParameter = key+"="+value;
	if(pageUrl.indexOf(key) !== -1){
		var oldSearchParameter= pageUrl.slice(pageUrl.indexOf(key), (pageUrl.indexOf("&",pageUrl.indexOf(key)) !== -1? pageUrl.indexOf("&",pageUrl.indexOf(key)):pageUrl.length));
		newUrl = pageUrl.replace(oldSearchParameter,newSearchParameter);
	}else if(pageUrl.indexOf("?") !== -1){
		newUrl = pageUrl.concat("&"+newSearchParameter);
	}else{
		newUrl = pageUrl.concat("?"+newSearchParameter);
	}
	history.replaceState(null, null, newUrl);
};

window.createSearchUrl = function() {
	// check if asian fit is enabled
	if ($("[name=isAsianFitAvailable]").length === 0) {
    	return window.persistSrchKeywords($('#utility-search-form #search-text-box').val(), true);
    }

	// check the cookie
	if (getCookie("AsianFitDefaultFilter") === null){
		// get default value and save cookie
		if ($('#asianFitDefaultDisplay').val() === 'ASIAN') {
			document.cookie = "AsianFitDefaultFilter=" + $('#AsianFitAsianFilter').val()+ ";path=/;";
		} else {
			document.cookie = "AsianFitDefaultFilter=" + $('#AsianFitInternationalFilter').val()+ ";path=/;";
		}
	}

	if ($('#AsianFitSearchTerms').length !== 0) {
		// check if search string contains strings that identifies asian frame
		var asianFitTerms = $('#AsianFitSearchTerms').val().toLowerCase().split("|");
		var searchTextInput = $('#search-text-box').val().toLowerCase();
		for (var i = 0; i < asianFitTerms.length; i++) {
			if (searchTextInput.indexOf(asianFitTerms[i]) >= 0) {
				document.cookie = "AsianFitDefaultFilter=" + $('#AsianFitAsianFilter').val() + ";path=/;";
			}
		}
		$('#search-text-box').val($('#search-text-box').val().trim());
	}

	$('#WC_CachedHeaderDisplay_facet').val(getCookie("AsianFitDefaultFilter"))
	return window.persistSrchKeywords($('#utility-search-form #search-text-box').val(), true);
};
